/** @jsx jsx */
import { jsx } from '@front10/base-elements';
import FocusLock from 'react-focus-lock';
import * as React from 'react';
import { useOverlay } from '@react-aria/overlays';

interface Props {
  popoverRef: React.RefObject<HTMLDivElement>;
  onClose?: () => void;
  activeTab?: number;
  isOpen?: boolean;
  currentTab?: number;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Dropdown = (props: React.PropsWithChildren<Props>) => {
  // const [isOpen, setOpen] = React.useState(false);
  // const onClose = props.onClose;
  const internalRef = React.useRef<HTMLDivElement>(null);

  let { popoverRef = internalRef, isOpen, onClose, children, ...rest } = props;

  // Handle events that should cause the popup to close,
  // e.g. blur, clicking outside, or pressing the escape key.
  let { overlayProps } = useOverlay(
    {
      isOpen,
      onClose,
      isDismissable: true,
      shouldCloseOnInteractOutside: (e) => {
        if (e.tagName.toLowerCase() === 'html') {
          return false;
        }
        onClose?.();
        return true;
      }
    },
    popoverRef
  );

  // Add a hidden <DismissButton> component at the end of the popover
  // to allow screen reader users to dismiss the popup easily.
  return (
    <FocusLock autoFocus returnFocus>
      <div
        {...overlayProps}
        sx={{
          position: 'absolute',
          zIndex: 1,
          variant: 'layout.popover'
        }}
        {...rest}
        ref={popoverRef}
      >
        {children}
      </div>
    </FocusLock>
  );
};
